import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import InputField from '../../components/InputField';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import { DAMGA_VERGISI_ORANI, KIDEM_TAVAN_UCRETLERI } from '../../constants/constants';
import LocalDatePicker from '../../components/LocalDatePicker';
import { differenceInDays } from 'date-fns';
import Header from '../../components/Header';

function getTavanUcreti(isten_cikis_tarih) {
    const cikisTarihi = new Date(isten_cikis_tarih);

    for (const ucret of KIDEM_TAVAN_UCRETLERI) {
        if (cikisTarihi <= ucret.tarih) {
            return ucret.tutar;
        }
    }

    return KIDEM_TAVAN_UCRETLERI[KIDEM_TAVAN_UCRETLERI.length - 1].tutar;
}

const faqs = [
    {
        question: "Kıdem tazminatı, işçinin işverene bağlı olarak çalıştığı süre boyunca emeğinin karşılığını almasını sağlayan bir haktır. İş akdinin sona ermesi halinde, belirli şartların sağlanması durumunda işçiye ödenir. Kıdem tazminatı, işçinin işyerinde geçirdiği her yıl için 30 günlük brüt ücretinin karşılığıdır.",
    },
    {
        question: "<h5>Kıdem tazminatı alabilmek için:</h5>",
        answer: [
            "İşçinin işyerinde en az 1 yıl çalışmış olması gerekir.",
            "İş sözleşmesinin işveren tarafından haklı bir neden olmaksızın sona erdirilmesi, iş sözleşmesinin işçi tarafından haklı nedenle sona erdirilmesi ya da kanunda özel olarak düzenlenmiş haller sebebiyle iş sözleşmesinin sona ermiş olması gerekmektedir.",
            "İş sözleşmesinin işveren tarafından haklı nedenle sona erdirilmesi durumunda işçi kıdem tazminatına hak kazanamayacaktır.",
            "İşçi ve işveren arasında belirli süreli iş sözleşmesi yapılmışsa ve iş akdi iş bu sürenin dolmasıyla veya sözleşmede yer alan şartın tamamlanmasıyla kendiliğinden sona ermişse işçi kıdem tazminatına hak kazanamayacaktır.",
        ],
    },
    {
        question: "<h5>Kıdem tazminatı hesaplaması:</h5>",
        answer: [
            "<strong>Hesaplamaya esas gün:</strong> İşçinin işyerinde fiilen çalıştığı günler ile hastalık, kaza, izin ve resmi tatiller gibi haklı gerekçelerle işe gelmediği günler de kıdem tazminatı hesabında dikkate alınır.",
            "<strong>Kıdem tazminatına esas ücret:</strong> Son brüt aylık ücretin, kıdem tazminatı hesaplama tarihindeki brüt asgari ücretin 4 katını geçmemesi gerekir.",
            "<strong>Kıdem tazminatı tutarı:</strong> İşçinin kıdem tazminatı tutarı, son ödenen aylık brüt ücretin çalışma yılı ile çarpılması sonucu hesaplanır. Bir yıldan artan süreler bakımından da aynı oran üzerinden hesaplama yapılmaktadır.",
        ],
    },
    {
        question: "<h5>Kıdem tazminatı ile ilgili önemli bilgiler:</h5>",
        answer: [
            "Kıdem tazminatından gelir vergisi ve sigorta primi kesintisi yapılmaz.",
            "Yalnızca damga vergisi kesintisi yapılarak kalan tutar işçiye ödenir.",
            "Kıdem tazminatı, iş akdinin sona erdiği tarihten itibaren en geç 30 gün içinde işçiye ödenmelidir.",
            "Kıdem tazminatı alacağı için 5 yıllık zamanaşımı süresi mevcuttur. 5 yıl içinde kıdem tazminatı alacağı talep edilmelidir.",
        ],
    },
];

const KidemTazminatiHesaplama = () => {
	const [hideAll, setHideAll] = useState(false);
	const [results, setResults] = useState([]);
	const [calculated, setCalculated] = useState(false);

	const [iseGirisTarihi, setIseGirisTarihi] = useState(new Date());
	const [istenCikisTarihi, setIstenCikisTarihi] = useState(new Date());

	const [brutMaas, setBrutMaas] = useState(null);
	const [yolYemek, setYolYemek] = useState(null);

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}
            setIseGirisTarihi(new Date(decodeURIComponent(atob(query.get('iseGirisTarihi')))));
            setIstenCikisTarihi(new Date(decodeURIComponent(atob(query.get('istenCikisTarihi')))));
            setBrutMaas(Number(decodeURIComponent(atob(query.get('brutMaas')))));
            setYolYemek(Number(decodeURIComponent(atob(query.get('yolYemek')))));
			setCalculated(true);
		}

		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
		if (iseGirisTarihi && istenCikisTarihi && brutMaas && yolYemek !== null) {
            if (iseGirisTarihi >= istenCikisTarihi) {
                alert("İşe giriş tarihiniz işten çıkış tarihinizden sonra olamaz.");
                return;
            }

            const tavan_ucret = getTavanUcreti(istenCikisTarihi);
            const hesaplanacak_deger = Math.min(brutMaas + yolYemek, tavan_ucret);
            const gun_farki = Math.abs(differenceInDays(istenCikisTarihi, iseGirisTarihi));

            const yil = Math.floor(gun_farki / 365);
            const kalan_gun = gun_farki % 365;
            const ay = Math.floor(kalan_gun / 30);
            const gun = kalan_gun % 30;
            const kidem_tazminati = hesaplanacak_deger * yil + hesaplanacak_deger * ay / 12 + hesaplanacak_deger * gun / 365;
            const damga_vergisi_kesintisi = kidem_tazminati * DAMGA_VERGISI_ORANI;
            const kidem = kidem_tazminati - damga_vergisi_kesintisi;

            const newResults = [
                { text: "Kıdem Tazminatınız (vergisiz)", value: kidem_tazminati },
                { text: "Damga Vergisi Oranı", value: DAMGA_VERGISI_ORANI },
                { text: "Damga Vergisi Kesintisi", value: damga_vergisi_kesintisi },
                { text: "Kıdem Tazminatınız (Son)", value: kidem },
            ];

            setHideAll(true);

            const params = new URLSearchParams({
				results: btoa(encodeURIComponent(JSON.stringify(newResults))),
				iseGirisTarihi: btoa(encodeURIComponent(new Date(iseGirisTarihi).toISOString())),
				istenCikisTarihi: btoa(encodeURIComponent(new Date(istenCikisTarihi).toISOString())),
                brutMaas: btoa(encodeURIComponent(brutMaas.toString())),
				yolYemek: btoa(encodeURIComponent(yolYemek.toString())),
			});

			navigate(`${window.location.pathname}?${params.toString()}`);
			navigate(0);
		} else {
			alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
		}
	};

    return (
        <>
            <Helmet>
                <title>Kıdem Tazminatı Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Kıdem tazminatı, işçinin iş akdi sona erdiğinde belirli şartlar altında emeğinin karşılığı olarak ödenen bir haktır." />
            </Helmet>

            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>Kıdem Tazminatı Hesaplama</li>
                    </ol>
                    <h1 className="fw-semibold">Kıdem Tazminatı Hesapla</h1>
                    <p>Kıdem tazminatı, işçinin iş akdi sona erdiğinde belirli şartlar altında emeğinin karşılığı olarak ödenen bir haktır.</p>
                    
                    <LocalDatePicker label="İşe Giriş Tarihiniz" setValue={setIseGirisTarihi} value={iseGirisTarihi} />
                    <LocalDatePicker label="İşten Çıkış Tarihiniz" setValue={setIstenCikisTarihi} value={istenCikisTarihi} />

                    <InputField value={brutMaas} setValue={setBrutMaas} trailText="TL" label="Brüt Maaşınız" type="number" />
                    <InputField value={yolYemek} setValue={setYolYemek} trailText="TL" label="Yol Yemek Ücretiniz" type="number" />
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} />
            </section>
            
            <Footer faqs={faqs} faqTitle="Kıdem Tazminatı Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(KidemTazminatiHesaplama);
